import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis } from "@/lib/lenis";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Legal from "@/pages/Legal";
import SolutionPage from "@/pages/SolutionPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import Dashboard from "@/pages/admin/Dashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import Suppliers from "@/pages/admin/Suppliers";
import QuoteComposer from "@/pages/admin/QuoteComposer";
import Proposal from "@/pages/Proposal";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  useEffect(() => {
    initLenis();
  }, []);

  // Auth callback must render synchronously when session_id is in the URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isBare = location.pathname.startsWith("/admin") || location.pathname.startsWith("/proposal");

  return (
    <div className="App bg-void min-h-screen">
      <ScrollManager />
      {!isBare && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="/solutions/:slug" element={<SolutionPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/leads/:leadId" element={<LeadDetail />} />
        <Route path="/admin/suppliers" element={<Suppliers />} />
        <Route path="/admin/leads/:leadId/quotes/new" element={<QuoteComposer />} />
        <Route path="/admin/quotes/:quoteId" element={<QuoteComposer />} />
        <Route path="/proposal/:quoteId" element={<Proposal />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isBare && <Footer />}
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
